import { Lines, Fade } from "./Reveal";

const Marquee = () => (
  <div className="overflow-hidden border-y border-[#F2F3F5]/20 py-6 md:py-8" data-testid="marquee">
    <div className="marquee">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="flex items-center gap-10 md:gap-16 pr-10 md:pr-16">
          <span className="display text-[2rem] md:text-[3.4rem] text-[#F2F3F5]">Telltag</span>
          <span className="h-2 w-2 rounded-full bg-[#F2F3F5]/50 block" />
        </div>
      ))}
    </div>
  </div>
);

export const Difference = () => (
  <section data-testid="difference-section" className="on-dark bg-[#0D1B2A] text-[#F2F3F5] pt-28 md:pt-44 overflow-hidden">
    <div className="grid grid-cols-12 gap-x-6 gap-y-14 px-6 md:px-10">
      <div className="col-span-12 md:col-span-7">
        <Lines
          lines={["Best before dates", "are built to be safe.", "Not to be accurate."]}
          className="display normal-case text-[1.6rem] sm:text-5xl lg:text-[4.2rem]"
          testId="difference-headline"
        />
      </div>
      <div className="col-span-12 md:col-span-4 md:col-start-9 md:pt-2">
        <Fade delay={0.3}>
          <p className="body-copy max-w-[34ch]">
            A printed date must cover the worst case, so it is set conservatively and never updates. Telltag replaces
            it with the measured state of the food: purple, consume; purple-yellow, consume today; yellow, discard.
          </p>
          <p className="display text-[2.2rem] sm:text-5xl lg:text-6xl mt-8 text-[#F2F3F5]" data-testid="difference-line">
            Waste less.
            <br />
            Stay safe.
          </p>
        </Fade>
      </div>
    </div>

    <div className="relative mt-20 md:mt-28 px-6 md:px-10">
      <div className="relative ml-auto w-full md:w-[70%] h-[60vw] md:h-[34vw] max-h-[560px] overflow-hidden">
        <img
          src="/assets/beef-package.webp"
          alt="Packaged meat with Telltag attached"
          loading="lazy"
          className="absolute right-[-18%] md:right-[-8%] top-[-4%] w-[130%] md:w-[104%] max-w-none"
          data-testid="difference-package"
        />
      </div>
    </div>

    <Marquee />
  </section>
);
